import { motion } from "framer-motion";
import { PhoneMockup } from "./PhoneMockup";

const S = "/assets/screens";

const SCREENS = [
  { src: `${S}/home-dashboard.jpeg`, label: "Home Dashboard" },
  { src: `${S}/contact-details.jpeg`, label: "Contact Details" },
  { src: `${S}/events.jpeg`, label: "Events" },
  { src: `${S}/goals.jpeg`, label: "Goals" },
  { src: `${S}/notifications.jpeg`, label: "Notifications" },
];

export const Showcase = () => (
  <section id="screenshots" className="overflow-hidden py-16 sm:py-24" data-testid="showcase-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <span className="text-xs font-semibold uppercase tracking-widest text-toto-blue" data-testid="showcase-eyebrow">App experience</span>
        <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-testid="showcase-heading">
          Designed to feel effortless
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
          A quick look inside TOTO — from your daily dashboard to goals, events and reminders.
        </p>
      </div>
    </div>
    <div className="mt-10 flex snap-x snap-mandatory gap-8 overflow-x-auto px-6 pb-8 sm:px-10 lg:justify-center" data-testid="showcase-scroller">
      {SCREENS.map((s, i) => (
        <motion.figure
          key={s.label}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.5, delay: i * 0.08 }}
          className="w-52 shrink-0 snap-center sm:w-60"
          data-testid={`showcase-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
        >
          <PhoneMockup src={s.src} alt={`TOTO ${s.label} screen`} className="aspect-[9/19]" />
          <figcaption className="mt-4 text-center text-sm font-semibold text-slate-700">{s.label}</figcaption>
        </motion.figure>
      ))}
    </div>
  </section>
);
